export default function Dot() {
  return (
    <span className="inline-flex justify-center items-center size-5 border border-primary rounded-full">
      <span className="inline-flex justify-center items-center size-3 bg-primary rounded-full"></span>
    </span>
  );
}
